import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=62556f6c"
import script from "./TypeSelector.vue?vue&type=script&lang=js"
export * from "./TypeSelector.vue?vue&type=script&lang=js"
import style0 from "./TypeSelector.vue?vue&type=style&index=0&id=62556f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports